import { useRouter } from 'next/router';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import CustomPopover from '../../Common/CustomPopover';
import RedDot from '../../Common/RedDot';
import ChatMenuContent from './ChatMenuContent';

const MdChatBubbleOutline = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdChatBubbleOutline)
);

export default function ChatMenu() {
  const router = useRouter();
  const isRouterChat = router.pathname == '/chats';
  const [showChatComponent, setShowChatComponent] = useState(true);

  const unreadChatExists = useSelector(
    ({ notifications }) => notifications?.unreadChatExists
  );

  return (
    <CustomPopover
      triggerComponent={
        <div className='relative h-[24px] w-[24px]'>
          <MdChatBubbleOutline
            className={`text-[24px] ${isRouterChat ? 'cursor-text' : ''}`}
          />
          {unreadChatExists ? <RedDot /> : null}
        </div>
      }
    >
      {!isRouterChat && showChatComponent && (
        <>
          <ChatMenuContent setShowChatComponent={setShowChatComponent} />
          <div className='h-[63px] md:hidden'></div>
        </>
      )}
    </CustomPopover>
  );
}
